import { PHONE_INPUT_WITH_EXTENSION_REGEX, GLOBAL_PHONE_REGEX } from 'constants/Regex.constants'
import { PhoneElements } from 'types/Util.type'

export function extractPhoneElements(phone: string): PhoneElements {
  if (!phone) {
    throw new Error('Phone number provided to extractPhoneElements is null or empty. Must provide non-empty string.')
  }

  const countryCode = phone.replace(/\s/g, '').substring(0, 2)
  const restOfPhone = phone.replace(/\s/g, '').substring(2)
  const [body, ...extensions] = restOfPhone.split(/,+/g)
  if (body.length !== 10) {
    throw new Error(
      `Invalid phone number body size. Expected 10 digits, but received ${body.length} digit${
        body.length === 1 ? '' : 's'
      }.`
    )
  }
  const pauses = restOfPhone ? Array.from(restOfPhone.matchAll(/,+/g), (m) => m[0]) : []

  if (extensions.length !== pauses.length) {
    throw new Error('Invalid phone number extension. Number of pauses do not match number of extensions.')
  }

  return {
    countryCode,
    body,
    extensions,
    pauses,
  }
}

export function convertFromStandardToWebLinkFormat(phone: string): string {
  try {
    const { countryCode, body, extensions, pauses } = extractPhoneElements(phone)
    let result = ''
    if (countryCode) result += `+01-`
    if (body) {
      result += `${body.slice(0, 3)}-${body.slice(3, 6)}-${body.slice(6)}`
    }
    if (extensions.length > 0) {
      extensions.forEach((extension, index) => {
        result += pauses[index].replace(/,/g, 'pp')
        result += extension
      })
    }

    return result
  } catch (e) {
    console.error(e)
    return ''
  }
}

export function convertFromStandardToBasic(phone: string): string {
  try {
    const { countryCode, body, extensions } = extractPhoneElements(phone)
    let result = ''
    if (countryCode) result += `${countryCode} `
    if (body) {
      result += `${body.slice(0, 3)}-${body.slice(3, 6)}-${body.slice(6)}`
    }
    if (extensions.length > 0) {
      extensions.forEach((extension) => {
        result += ` x${extension}`
      })
    }

    return result
  } catch (e) {
    console.error(e)
    return ''
  }
}

export function convertFromStandardToDisplay(phone: string): string {
  if (!phone) {
    return ''
  }

  const phoneArr = GLOBAL_PHONE_REGEX.exec(phone.replace(/\s/g, ''))
  GLOBAL_PHONE_REGEX.lastIndex = 0
  if (phoneArr) {
    const extension = phoneArr[4] ? phoneArr[4] : ''
    return `+1 (${phoneArr[1]}) ${phoneArr[2]}-${phoneArr[3]}${extension}`
  }
  return phone
}

export function convertFromDisplayToStandard(phone: string): string {
  if (!phone) {
    return ''
  }

  const phoneArr = PHONE_INPUT_WITH_EXTENSION_REGEX.exec(phone)
  PHONE_INPUT_WITH_EXTENSION_REGEX.lastIndex = 0
  if (phoneArr) {
    const extension = phoneArr[4] ? phoneArr[4] : ''
    const convertedPhone = `+1${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}${extension}`
    if (convertedPhone.match(GLOBAL_PHONE_REGEX)) {
      return convertedPhone
    }
  }
  return ''
}
